import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { IMessage } from '.';
import api from '..';

export interface IConversationUnreadCount {
  conversation_id: number;
  count: number;
  last_unread_message_id: number;
  last_message_created_at: string;
}
export interface IGetUnreadMessagesCount {
  data: IConversationUnreadCount[];
  total_count: number;
}

const e = api.injectEndpoints({
  endpoints: (builder) => ({
    getUnreadMessagesCount: builder.query<IGetUnreadMessagesCount, void>({
      query: (args) => `/conversations/unread-messages-count`,
    }),
  }),
});

export const {
  useGetUnreadMessagesCountQuery,
  useLazyGetUnreadMessagesCountQuery,
} = e;
